import { envCfg } from '../env/config';

const html = document.documentElement.innerHTML;
document.documentElement.innerHTML = html.replace('%APP_VERSION%', envCfg.APP_VERSION);
